// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"98636665","361":"8d0b4c5f","412":"9840c7b4","429":"62bcded0","488":"7c362255","493":"f7443449","525":"e1dada43","604":"4257212c","734":"c65b5a4d","786":"d547b9ff","820":"0bb07df6","846":"5f38290d","868":"43381581"}[chunkId] + ".chunk.js";
};